import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { rootRoute } from '../../config';
import Button from './Button';
import close_button from '../../assets/close_button.png';

const Footer = ({ setIsOverlay, setToggleSimulation, isExitPopup, setIsExitPopup, isOverlay, isPopupOverlay, simType }) => {
  const [popupLeft, setPopupLeft] = useState(0);
  const [currentYear, setCurrentYear] = useState(null);
  const handlePopupExitSim = (e) => {
    window.close();
  }
  const handlePopupClose = (e) => {
    setIsExitPopup(false);
    setIsOverlay(false);
  }

  const footerPopupBtnStyle = {
    Color: "rgb(255, 255, 255)",
    backgroundColor: "#B2347B",
    padding: "8px 12px",
    borderRadius: "30px",
    margin: "0px 5px",
  }
  useEffect(() => {
    const getCurrentYear = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        setCurrentYear(year);
    };
    getCurrentYear();
  },[]);
  useEffect(() => {
    if (window.$("#exit-popup").length > 0) {
      let newLeft = window.$(".footer-links .listitem:last").offset().left - window.$("#exit-popup").offset().left + 15;
      setPopupLeft(newLeft);
    }
  }, [isExitPopup])
  return (
    <footer className="footer" aria-hidden={isPopupOverlay}>
      <div className="container" style={window.location.href.includes("/prework") ? {justifyContent : 'center'} : {}}>
        <div>
          <span className="copyright-text">Copyright &#169;{currentYear} </span>
          <ul className="footer-links">
            <li className="listitem"><a href="https://www.pearson.com/en-us.html" target='_blank'>Pearson Education</a></li>
            <li className="listitem"><span aria-hidden="true" role="presentation">&nbsp;|&nbsp;</span></li>
            <li className="listitem"><a href="https://loginstatic.pearson.com/html/PearsonPrivacyPolicy.html?" target='_blank'>Privacy Policy</a></li>
          </ul>
        </div>
        {
         !(window.location.href.includes("/prework")) ? <div className='footer-nav'>
          <ul className="footer-links">
            <li className="listitem">
              {/* <Link to={`${rootRoute}/${simType.toLowerCase()}?from=footer`}>
                <em className="info circle icon" aria-hidden="true" role="presentation"></em>
                <span>View Tutorial</span>
              </Link> */}
              <Link to={`${rootRoute}/${simType?.toLowerCase()}?from=simulation`}>
              <i className="info circle icon" aria-hidden="true" role="presentation"></i>
              <span>Introduction</span>
              </Link>
            </li>
            <li className="listitem">
              <a href="#" role="button" onClick={(e) => {
                e.preventDefault();
                setToggleSimulation(false);
                setIsExitPopup(true);
                setIsOverlay(true);
              }}>
                <i className="sign out alternate icon" aria-hidden="true" role="presentation"></i>
                <span>Exit</span>
              </a>
              {
                isExitPopup &&
                <div id="exit-popup" className="ui pointing below label" tabIndex={0} role='dialog' style={{ "--left": `${popupLeft}px` }}>
                  <div className="exit-content">
                    <h2 className="exit-header exit-item" >Please specify one of the following actions to proceed</h2>
                    <hr aria-hidden="true" role="presentation" />
                    <div className="exit-item">Exit: You can resume this instance later.</div>
                    { window.location.href.indexOf("preview") != -1 && <div className="exit-item">Abort: This instance will close and no data will be recorded.</div>}
                    <div className="exit-item">Cancel: Cancel and go back to the simulation.</div>
                    <hr aria-hidden="true" role="presentation" />
                    <div className="exit-buttons">

                      <Button btnName="Exit" btnId="exitSimulationBtn" customBtnStyle={footerPopupBtnStyle} clickEventHandler={handlePopupExitSim} />
                      {window.location.href.indexOf("preview") != -1 && <Button btnName="Abort" btnId="abortSimulationBtn" customBtnStyle={footerPopupBtnStyle} clickEventHandler={handlePopupExitSim} />}
                      <Button btnName="Cancel" btnId="cancelSimulationBtn" customBtnStyle={footerPopupBtnStyle} clickEventHandler={handlePopupClose} />

                    </div>
                  </div>
                </div>

              }
            </li>
            {/* <li className="listitem skip-intro">
              <Link to={`${rootRoute}/im/simulation`} role="button">
              <em className="sign out alternate icon"></em>
                <span>{"Skip Intro"}</span>
              </Link>
            </li> */}

          </ul>
          </div> 
          : ""
        }
      </div>
    </footer>
  )
}

export default Footer